export const Paths = {
  base: "/",
  nf: "*",
  login: "login",
  pucform: "wonder-world",
  wonderworldquick: "wonder-world-quick",
  keySoulStore:"keysoul-store",
  displayWall:"/display-wall",
  displayWallStore:"/store",
  userDashboard: "/dashboard",
  userPayment: "/payment",  
  userNotification: "/notification",
  home: "/admin/home",
  allRequest: "/admin/all-request",
  locationCheck: "/admin/location-check",
  locationCheckException: "/admin/location-check-exception",
  docVerification: "/admin/doc-verfication",
  furnitureSetup: "/admin/furniture-setup",
  depositcheck: "/admin/deposit-check",
  materialDispatch: "/admin/material-dispatch",
  materialHandover: "/admin/material-handover",
  manageRoles: "/admin/Manage_Roles",
  manageUsers: "/admin/Manage_Users",
  forgotpassword: "forgot-password",
  manageBanks: "/admin/manage-banks",
  manageBranches: "/admin/manage-branches",
  furnitureItem: "/admin/furniture-Item",
  furnitureTemplate: "/admin/furniture-template",
  furnitureFixtures: "/admin/furniture-fixtures",
  paymentManagement: "/admin/payment-management",
  paymentManagementException: "/admin/payment-management-exception",
  rcmBankManagement: "/admin/rcm-bank-managment",
  notification: "/admin/notification",
  displayWallEcom:"/display-wall-ecom",
};

export const publicPaths = ["/", "*", "login", "forgot-password", "display-wall-ecom"];
